// extracted by mini-css-extract-plugin
export default {"edenredIntegrationWrapper":"EdenredReportForm_edenredIntegrationWrapper__hJC41","edenredForm":"EdenredReportForm_edenredForm__zV-D2"};